import DeedCard from './DeedCard';

export default DeedCard;
